export function getWindowOffsets() {
	return {
		bottom: window.innerHeight,
		left: 0,
		right: window.innerWidth,
		top: 0,
	};
}
